import axios from 'axios';

import { POST_EMIT_POLICY_URL } from '../constants/constants';

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json;charset=utf-8',
});

export const postEmitPolicy = (token, data) => {
  return axios.post(POST_EMIT_POLICY_URL, data, { headers: headers(token) });
};
